module.exports = __webpack_public_path__ + "img/bottom_bg.61718a60.png";